import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { localePath } from "@/i18n/localePath";
import { useTranslation } from "react-i18next";

const AUTH_TIMEOUT_MS = 8000;

const ProtectedRoute: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const { i18n } = useTranslation();
  const location = useLocation();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!loading) return;
    const id = setTimeout(() => setTimedOut(true), AUTH_TIMEOUT_MS);
    return () => clearTimeout(id);
  }, [loading]);

  if (loading && !timedOut) {
    return (
      <div className="flex items-center justify-center min-h-[100dvh] bg-chat-bg">
        <span className="text-4xl animate-pulse">🐾</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={localePath("/auth", i18n.language)} state={{ from: location }} replace />;
  }

  // Support both layout route (Outlet) and wrapper (children) usage
  return <>{children ?? <Outlet />}</>;
};

export default ProtectedRoute;
